import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const ReferralReportForm = ({selectedFormId,currentId,data,selectedClientDetails}) => {
  const { t } = useTranslation();
const initialFormData =     {
    clientName: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    clientEmail: "",
    clientTel: "",
    practitionerName: "",
    practitionerEmail: "",
    practitionerTel: "",
    referralReason: "",
    breathingChallengesOutcome: "",
    breathingIssues: {
      abortedExhale: { checked: false, comment: "" },
      airHunger: { checked: false, comment: "" },
      anxietyAboutBreathing: { checked: false, comment: "" },
      assistingTheInhale: { checked: false, comment: "" },
      breathHolding: { checked: false, comment: "" },
      chestBreathing: { checked: false, comment: "" },
      effortfulBreathing: { checked: false, comment: "" },
      faultyBeliefs: { checked: false, comment: "" },
      forcedExhalation: { checked: false, comment: "" },
      gasping: { checked: false, comment: "" },
      intentionalManipulations: { checked: false, comment: "" },
      muscleActivity: { checked: false, comment: "" },
      mouthBreathing: { checked: false, comment: "" },
      noHesitation: { checked: false, comment: "" },
      overbreathingPetCo2: { checked: false, comment: "" },
      rapidBreathing: { checked: false, comment: "" },
      reachingForAir: { checked: false, comment: "" },
      reverseBreathing: { checked: false, comment: "" },
      shallowBreathing: { checked: false, comment: "" },
      shortnessOfBreath: { checked: false, comment: "" },
      symptomsAssociated: { checked: false, comment: "" },
      takesDeepBreaths: { checked: false, comment: "" },
      worriedAboutBreathing: { checked: false, comment: "" },
      other: { checked: false, comment: "" },
    },
    petCo2Changes: {
      breathingMechanics: { checked: false, comment: "" },
      intentionalManipulation: { checked: false, comment: "" },
      conversationalContent: { checked: false, comment: "" },
      emotions: { checked: false, comment: "" },
      physicalDiscomfort: { checked: false, comment: "" },
      posturalChanges: { checked: false, comment: "" },
      pain: { checked: false, comment: "" },
      other: { checked: false, comment: "" },
    },
    petCo2Measurements: {
      overbreathingPresent: "",
      initialBaselineValues: "",
      symptomsReported: "",
      riseToNormal: "",
      assistToRaise: "",
      successful: "",
      trappedInOverbreathing: "",
    },
    co2ScreenShots: false,
  }
  const [formData, setFormData] = useState(data?data:initialFormData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (section, item) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [item]: {
          ...prev[section][item],
          checked: e.target.checked,
        }
      }
    }));
  };

  const handleCommentChange = (section, item) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [item]: {
          ...prev[section][item],
          comment: e.target.value,
        }
      }
    }));
  };

  const handleRadioChange = (group, name, value) => {
    setFormData((prev) => ({
      ...prev,
      [group]: {
        ...prev[group],
        [name]: value,
      }
    }));
  };

  const handleSimpleRadioChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      petCo2Measurements: {
        ...prev.petCo2Measurements,
        [name]: value,
      }
    }));
  };

 const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = (e) => {
  e.preventDefault();
  
  
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
    session_id: localStorage.getItem("selectedSession") || null,
  };

  console.log("📤 Sending form payload test:", payload);

  fetch(API_URL + "/forms/trainer/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};

  const breathingIssueFields = [
    { key: "abortedExhale", label: "Aborted exhale (not exhaling completely)" },
    { key: "airHunger", label: "Air hunger" },
    { key: "anxietyAboutBreathing", label: "Anxiety about breathing" },
    { key: "assistingTheInhale", label: "Assisting the inhale" },
    { key: "breathHolding", label: "Breath holding" },
    { key: "chestBreathing", label: "Chest breathing" },
    { key: "effortfulBreathing", label: "Effortful breathing" },
    { key: "faultyBeliefs", label: "Faulty beliefs about breathing" },
    { key: "forcedExhalation", label: "Forced exhalation" },
    { key: "gasping", label: "Gasping, sighing" },
    { key: "intentionalManipulations", label: "Intentional breathing manipulation" },
    { key: "muscleActivity", label: "Muscle activity tied to breathing" },
    { key: "mouthBreathing", label: "Mouth breathing" },
    { key: "noHesitation", label: "No hesitation between exhale and inhale" },
    { key: "overbreathingPetCo2", label: "Overbreathing (PetCO₂, range?)" },
    { key: "rapidBreathing", label: "Rapid breathing" },
    { key: "reachingForAir", label: "Reaching for air" },
    { key: "reverseBreathing", label: "Reverse breathing" },
    { key: "shallowBreathing", label: "Shallow breathing" },
    { key: "shortnessOfBreath", label: "Shortness of breath" },
    { key: "symptomsAssociated", label: "Symptoms associated with breathing" },
    { key: "takesDeepBreaths", label: "Takes deep breaths" },
    { key: "worriedAboutBreathing", label: "Worried about breathing" },
    { key: "other", label: "OTHER" },
  ];

  const petCo2ChangeFields = [
    { key: "breathingMechanics", label: "Change in breathing mechanics" },
    { key: "intentionalManipulation", label: "Intentional manipulation of breathing" },
    { key: "conversationalContent", label: "Conversational content" },
    { key: "emotions", label: "Emotions" },
    { key: "physicalDiscomfort", label: "Physical discomfort" },
    { key: "posturalChanges", label: "Postural (kinesthetic) changes" },
    { key: "pain", label: "Pain" },
    { key: "other", label: "OTHER" }
  ];

  return (
    <div style={{
      fontFamily: "Arial, sans-serif",
      maxWidth: "1200px",
      margin: "0 auto",
      marginTop: "20px",
     padding: !data?"20px":"10px",
      border: !data && "1px solid #ccc",
    }}>
      <h1 style={{
        color: "#0078d4",
        textAlign: "center",
        fontSize: "24px",
        fontWeight: "bold"
      }}>REFERRAL REPORT</h1>

      <p style={{ textAlign: "center", fontSize: "14px", marginBottom: "10px" }}>
        Please save this file in your client's name, e.g., smithreferral.pdf.
        Then upload it to your client's folder on the BSN portal.
      </p>
          <p
        style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}
      >
        Go to{" "}
        <a
          href="https://breathingsciencenetwork.com/"
          style={{ color: "#0078d4" }}
        >
          https://breathingsciencenetwork.com/
        </a>{" "}
        and click on DASHBOARD LOGIN.
      </p>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
          <label>Client Name:
            <input type="text" disabled={Boolean(selectedClientDetails)} name="clientName" value={formData.clientName} onChange={handleInputChange} style={inputStyle} />
          </label>
          <label>Email:
            <input type="email" name="clientEmail" value={formData.clientEmail} onChange={handleInputChange} style={inputStyle} />
          </label>
          <label>Tel:
            <input type="tel" name="clientTel" value={formData.clientTel} onChange={handleInputChange} style={inputStyle} />
          </label>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
          <label>Practitioner Name:
            <input type="text" name="practitionerName" value={formData.practitionerName} onChange={handleInputChange} style={inputStyle} />
          </label>
          <label>Email:
            <input type="email" name="practitionerEmail" value={formData.practitionerEmail} onChange={handleInputChange} style={inputStyle} />
          </label>
          <label>Tel:
            <input type="tel" name="practitionerTel" value={formData.practitionerTel} onChange={handleInputChange} style={inputStyle} />
          </label>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={bigLabel}>
            Why did you decide to make a referral?{" "}
                 <span style={{ fontWeight: "normal", color: "black" }}>
            Example: "Because of what I saw on the "Your Breathing Habits" form.
          </span>
          </label>
          <textarea
            name="referralReason"
            value={formData.referralReason}
            onChange={handleInputChange}
            style={textAreaStyle}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={bigLabel}>
            Did you notice any of the following during your interview?{" "}
            <span style={{ fontWeight: "normal", color: "black" }}>
              If you have comments, write them in the space provided for each item.
            </span>
          </label>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ width: "50%", paddingRight: "10px", boxSizing: "border-box" }}>
              {breathingIssueFields.slice(0, Math.ceil(breathingIssueFields.length / 2)).map(field => (
                <div key={field.key} style={checkboxRowStyle}>
                  <input
                    type="checkbox"
                    id={field.key}
                    checked={formData.breathingIssues[field.key].checked}
                    onChange={handleCheckboxChange("breathingIssues", field.key)}
                  />
                  <label htmlFor={field.key} style={{ fontSize: "14px", width: "200px" }}>{field.label}</label>
                  <input
                    type="text"
                    value={formData.breathingIssues[field.key].comment}
                    onChange={handleCommentChange("breathingIssues", field.key)}
                    style={commentInputStyle}
                  />
                </div>
              ))}
            </div>
            <div style={{ width: "50%", paddingLeft: "10px", boxSizing: "border-box" }}>
              {breathingIssueFields.slice(Math.ceil(breathingIssueFields.length / 2)).map(field => (
                <div key={field.key} style={checkboxRowStyle}>
                  <input
                    type="checkbox"
                    id={field.key}
                    checked={formData.breathingIssues[field.key].checked}
                    onChange={handleCheckboxChange("breathingIssues", field.key)}
                  />
                  <label htmlFor={field.key} style={{ fontSize: "14px", width: "200px" }}>{field.label}</label>
                  <input
                    type="text"
                    value={formData.breathingIssues[field.key].comment}
                    onChange={handleCommentChange("breathingIssues", field.key)}
                    style={commentInputStyle}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={bigLabel}>
            Did you notice any changes in PetCO₂ levels during the interview?{" "}
            <span style={{ fontWeight: "normal", color: "black" }}>
              If so, did any of the following seem to trigger the change?
            </span>
          </label>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ width: "50%", paddingRight: "10px", boxSizing: "border-box" }}>
              {petCo2ChangeFields.slice(0, Math.ceil(petCo2ChangeFields.length / 2)).map(field => (
                <div key={field.key} style={checkboxRowStyle}>
                  <input
                    type="checkbox"
                    id={field.key}
                    checked={formData.petCo2Changes[field.key].checked}
                    onChange={handleCheckboxChange("petCo2Changes", field.key)}
                  />
                  <label htmlFor={field.key} style={{ width: "200px" }}>{field.label}</label>
                  <input
                    type="text"
                    value={formData.petCo2Changes[field.key].comment}
                    onChange={handleCommentChange("petCo2Changes", field.key)}
                    style={commentInputStyle}
                  />
                </div>
              ))}
            </div>
            <div style={{ width: "50%", paddingLeft: "10px", boxSizing: "border-box" }}>
              {petCo2ChangeFields.slice(Math.ceil(petCo2ChangeFields.length / 2)).map(field => (
                <div key={field.key} style={checkboxRowStyle}>
                  <input
                    type="checkbox"
                    id={field.key}
                    checked={formData.petCo2Changes[field.key].checked}
                    onChange={handleCheckboxChange("petCo2Changes", field.key)}
                  />
                  <label htmlFor={field.key} style={{ width: "200px" }}>{field.label}</label>
                  <input
                    type="text"
                    value={formData.petCo2Changes[field.key].comment}
                    onChange={handleCommentChange("petCo2Changes", field.key)}
                    style={commentInputStyle}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={bigLabel}>
            Did you introduce any breathing challenges during the interview, e.g., overbreathing?{" "}
            <span style={{ fontWeight: "normal", color: "black" }}>
              If so, what were they and what were the outcomes?
            </span>
          </label>
          <textarea
            name="breathingChallengesOutcome"
            value={formData.breathingChallengesOutcome}
            onChange={handleInputChange}
            style={textAreaStyle}
          />
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={bigLabel}>
            Did you make PetCO₂ measurements?{" "}
            <span style={{ fontWeight: "normal", color: "black" }}>
              If so, please answer the questions below. Make comments in the space provided.
            </span>
          </label>
          <div style={radioGroupStyle}>
            <label>Was overbreathing (below 35 mmHg) present at the start of the session?</label>
            <input type="radio" name="overbreathingPresent" checked={formData.petCo2Measurements.overbreathingPresent === "Yes"} onChange={() => handleSimpleRadioChange("overbreathingPresent", "Yes")} /> Yes
            <input type="radio" name="overbreathingPresent" checked={formData.petCo2Measurements.overbreathingPresent === "No"} onChange={() => handleSimpleRadioChange("overbreathingPresent", "No")} /> No
          </div>
          <div style={radioGroupStyle}>
            <label>What were the initial baseline PetCO₂ values (first two minutes)?</label>
            <input
              type="text"
              name="initialBaselineValues"
              value={formData.petCo2Measurements.initialBaselineValues}
              onChange={e => handleRadioChange("petCo2Measurements", "initialBaselineValues", e.target.value)}
              style={commentInputStyle}
            />
          </div>
          <div style={radioGroupStyle}>
            <label>What symptoms/deficits were reported, if any?</label>
            <input
              type="text"
              name="symptomsReported"
              value={formData.petCo2Measurements.symptomsReported}
              onChange={e => handleRadioChange("petCo2Measurements", "symptomsReported", e.target.value)}
              style={commentInputStyle}
            />
          </div>
          <div style={radioGroupStyle}>
            <label>If Values were below 35, did they rise to normal within the next few minutes?</label>
            <input type="radio" name="riseToNormal" checked={formData.petCo2Measurements.riseToNormal === "Yes"} onChange={() => handleSimpleRadioChange("riseToNormal", "Yes")} /> Yes
            <input type="radio" name="riseToNormal" checked={formData.petCo2Measurements.riseToNormal === "No"} onChange={() => handleSimpleRadioChange("riseToNormal", "No")} /> No
          </div>
          <div style={radioGroupStyle}>
            <label>If not did you try to assist your client to raise the PetCO₂ levels to normal?</label>
            <input type="radio" name="assistToRaise" checked={formData.petCo2Measurements.assistToRaise === "Yes"} onChange={() => handleSimpleRadioChange("assistToRaise", "Yes")} /> Yes
            <input type="radio" name="assistToRaise" checked={formData.petCo2Measurements.assistToRaise === "No"} onChange={() => handleSimpleRadioChange("assistToRaise", "No")} /> No
          </div>
          <div style={radioGroupStyle}>
            <label>If so, were you successful?</label>
            <input type="radio" name="successful" checked={formData.petCo2Measurements.successful === "Yes"} onChange={() => handleSimpleRadioChange("successful", "Yes")} /> Yes
            <input type="radio" name="successful" checked={formData.petCo2Measurements.successful === "No"} onChange={() => handleSimpleRadioChange("successful", "No")} /> No
          </div>
          <div style={radioGroupStyle}>
            <label>Did your client seem to be trapped in overbreathing?</label>
            <input type="radio" name="trappedInOverbreathing" checked={formData.petCo2Measurements.trappedInOverbreathing === "Yes"} onChange={() => handleSimpleRadioChange("trappedInOverbreathing", "Yes")} /> Yes
            <input type="radio" name="trappedInOverbreathing" checked={formData.petCo2Measurements.trappedInOverbreathing === "No"} onChange={() => handleSimpleRadioChange("trappedInOverbreathing", "No")} /> No
          </div>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <label style={bigLabel}>
            Did you take any screen shots of CO₂ graphs?
            <span style={{ fontWeight: "normal", color: "black" }}>
              If so, please convert them to a PDF file and upload to the client folder in the BSN portal.
            </span>
          </label>
          <input type="checkbox" checked={formData.co2ScreenShots} onChange={e => setFormData((prev) => ({ ...prev, co2ScreenShots: e.target.checked }))} />
        </div>
 
        {!data &&  <div className="client-submit-btn">
        <button type="submit" onClick={handleSubmit}>
          {loading?t("Submitting..."):t("Submit")}
        </button>
      </div>}
      </form>
          <Modal
                                                              isOpen={successModal}
                                                              toggle={successToggleModal}
                                                              className="connect-box"
                                                              centered={true}
                                                            >
                                                              <ModalHeader toggle={successToggleModal}>
                                                                <span className="ml-1 roititle font-weight-bold">
                                                                  Successfull
                                                                </span>
                                                              </ModalHeader>
                                                              <ModalBody>
                                                                <div className="modal-p">
                                                                  <p>Trainer form has been submitted successfully.</p>
                                                                </div>
                                                              </ModalBody>
                                                            </Modal>
    </div>
  );
};

const inputStyle = {
  minWidth: "180px",
  flex: 1,
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  borderBottom: "1px solid #000",
  outline: "none",
  padding: "5px 0",
  backgroundColor: "#f1f4ff",
  marginLeft: "5px",
  marginRight: "5px",
};

const commentInputStyle = {
  width: "200px",
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  borderBottom: "1px solid #000",
  outline: "none",
  backgroundColor: "#f1f4ff",
  height: "30px",
  marginLeft: "5px",
};
const textAreaStyle = {
  width: "100%",
  minHeight: "70px",
  border: "1px solid #000",
  padding: "5px",
  backgroundColor: "#f1f4ff",
  borderRadius: "3px",
};
const submitButtonStyle = {
  marginTop: "25px",
  padding: "10px 25px",
  backgroundColor: "#0078d4",
  color: "white",
  border: "none",
  borderRadius: "4px",
  fontSize: "16px",
  cursor: "pointer",
};
const bigLabel = { color: "#0078d4", fontWeight: "bold", display: "block", marginBottom: "5px" };
const checkboxRowStyle = { display: "flex", alignItems: "center", marginBottom: "5px", gap: "8px" };
const radioGroupStyle = { display: "flex", alignItems: "center", marginBottom: "10px", gap: "10px" };

export default ReferralReportForm;
